import SEOHead from '../../components/feature/SEOHead';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import MinistriesSection from './components/MinistriesSection';
import MissionFields from './components/MissionFields';
import PartnerChurches from './components/PartnerChurches';
import SupportMethod from './components/SupportMethod';
import SupportProcess from './components/SupportProcess';
import FieldNews from './components/FieldNews';
import WednesdayPrayer from './components/WednesdayPrayer';
import KBMNews from './components/KBMNews';
import InquirySection from './components/InquirySection';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '킹덤브릿지미션 (Kingdom Bridge Mission)',
    alternateName: 'KBM',
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    image: 'https://static.readdy.ai/image/8c75b34306599e28cafd501142ec58d6/6544712b4051e0bdfd79201f42094c9a.png',
    description:
      '킹덤브릿지미션(KBM)은 나라와 나라, 교회와 교회를 연결하는 영적 네트워킹 선교단체입니다. 선교사파송, 글로벌선교 후원, 미자립교회 지원, 신학교육을 통해 하나님 나라를 세웁니다.',
    telephone: '010-8524-9200',
    email: 'svkdavid@hanmail.net',
    sameAs: [
      'https://www.facebook.com/profile.php?id=100002398088088',
      'https://www.instagram.com/kbm_2025',
      'https://www.youtube.com/@bridgemission2025',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '010-8524-9200',
      contactType: 'customer service',
      availableLanguage: 'Korean',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '킹덤브릿지미션 KBM',
    url: SITE_URL,
    inLanguage: 'ko',
    description:
      '킹덤브릿지미션(KBM) 공식 웹사이트 - 선교단체 후원, 선교사파송, 글로벌선교',
    publisher: {
      '@type': 'Organization',
      name: '킹덤브릿지미션 (Kingdom Bridge Mission)',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE_URL}/`,
    url: `${SITE_URL}/`,
    name: '킹덤브릿지미션(KBM) - 선교단체 후원 · 선교사파송 · 글로벌선교',
    description:
      '킹덤브릿지미션(KBM)은 나라와 나라, 교회와 교회를 연결하는 영적 네트워킹 선교단체입니다. 선교사파송, 글로벌선교 후원, 미자립교회 지원, 신학교육을 통해 하나님 나라를 세웁니다.',
    inLanguage: 'ko',
    isPartOf: { '@id': SITE_URL },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '홈',
          item: `${SITE_URL}/`,
        },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '킹덤브릿지미션(KBM)은 어떤 단체인가요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '킹덤브릿지미션(KBM)은 나라와 나라, 도시와 도시, 교회와 교회를 연결하는 영적 네트워킹 선교단체입니다. 선교사파송, 글로벌선교 후원, 미자립교회 지원, 신학교육 등을 통해 하나님 나라를 세웁니다.',
        },
      },
      {
        '@type': 'Question',
        name: 'KBM 후원은 어떻게 할 수 있나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '홈페이지 후원방법 섹션을 통해 정기후원 및 일시후원이 가능합니다. 문의하기 섹션을 통해 연락주시면 자세한 안내를 드립니다.',
        },
      },
      {
        '@type': 'Question',
        name: 'KBM의 주요 사역은 무엇인가요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'KBM의 주요 사역은 선교지 리포팅 & 미디어 사역, 선교사 멤버 케어 & 전략적 후원, 글로벌 신학 교육, 미자립교회 협력 및 지원, 영적 발전소(수요 기도) 등입니다.',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="킹덤브릿지미션(KBM) - 선교단체 후원 · 선교사파송 · 글로벌선교"
        description="킹덤브릿지미션(KBM)은 나라와 나라, 교회와 교회를 연결하는 영적 네트워킹 선교단체입니다. 선교사파송, 글로벌선교 후원, 미자립교회 지원, 신학교육을 통해 하나님 나라를 세웁니다. 지금 후원에 동참하세요."
        keywords="킹덤브릿지미션, KBM, 선교단체, 선교사파송, 글로벌선교, 후원, 미자립교회, 선교후원, 기독교선교"
        canonicalPath="/"
        schemaJson={homeSchemas}
      />
      <Navbar />
      <Hero />
      <AboutSection />
      <MinistriesSection />
      <MissionFields />
      <PartnerChurches />
      <SupportMethod />
      <SupportProcess />
      <FieldNews />
      <WednesdayPrayer />
      <KBMNews />
      <InquirySection />
      <Footer />
    </div>
  );
}
